// Types d'éléments disponibles
export const ELEMENT_TYPES = {
    TEXT: 'text',
    RICHTEXT: 'richtext',
    IMAGE: 'image',
    PROFILEPHOTO: 'profilephoto',
    ORGLOGO: 'orglogo',
    BANNER: 'banner',
    BUTTON: 'button',
    ICONTEXT: 'icontext',
    DIVIDER: 'divider',
    SPACER: 'spacer',
    SOCIAL: 'social',
    SOCIALGROUP: 'socialgroup',
    QRCODE: 'qrcode'
};

// Éléments draggables pour le panneau gauche
export const DRAGGABLE_ELEMENTS = [
    {
        type: ELEMENT_TYPES.TEXT,
        label: 'Texte',
        icon: '📝',
        defaultValue: 'Votre texte ici',
        defaultStyle: { color: '#000', fontSize: '14px', fontWeight: 'normal', fontStyle: 'normal', textDecoration: 'none', textAlign: 'left', marginTop: '0px', marginRight: '0px', marginBottom: '0px', marginLeft: '0px' }
    },
    {
        type: ELEMENT_TYPES.RICHTEXT,
        label: 'Texte enrichi',
        icon: '📄',
        defaultValue: '<p>Texte enrichi</p>',
        defaultStyle: { marginTop: '0px', marginRight: '0px', marginBottom: '0px', marginLeft: '0px' }
    },
    {
        type: ELEMENT_TYPES.IMAGE,
        label: 'Image',
        icon: '🖼️',
        defaultValue: '',
        defaultStyle: { width: '200px', height: 'auto', textAlign: 'left', marginTop: '0px', marginRight: '0px', marginBottom: '0px', marginLeft: '0px' }
    },
    {
        type: ELEMENT_TYPES.PROFILEPHOTO,
        label: 'Photo de profil',
        icon: '👤',
        defaultValue: '',
        defaultStyle: { width: '100px', height: '100px', imageShape: 'circle', textAlign: 'left', marginTop: '0px', marginRight: '0px', marginBottom: '0px', marginLeft: '0px' }
    },
    {
        type: ELEMENT_TYPES.ORGLOGO,
        label: 'Logo organisation',
        icon: '🏢',
        defaultValue: '',
        defaultStyle: { width: '150px', height: 'auto', textAlign: 'left', marginTop: '0px', marginRight: '0px', marginBottom: '0px', marginLeft: '0px' }
    },
    {
        type: ELEMENT_TYPES.BANNER,
        label: 'Bannière',
        icon: '🎨',
        defaultValue: '',
        defaultStyle: { height: '150px', marginTop: '0px', marginRight: '0px', marginBottom: '0px', marginLeft: '0px' },
        link: '#'
    },
    {
        type: ELEMENT_TYPES.BUTTON,
        label: 'Bouton',
        icon: '🔘',
        defaultValue: 'Cliquez ici',
        defaultStyle: { backgroundColor: '#3498db', color: '#fff', padding: '12px 24px', borderRadius: '6px', marginTop: '0px', marginRight: '0px', marginBottom: '0px', marginLeft: '0px' },
        link: '#'
    },
    {
        type: ELEMENT_TYPES.ICONTEXT,
        label: 'Icône + Texte',
        icon: '📱',
        defaultValue: 'contact@email.com',
        iconValue: '📧',
        textValue: 'contact@email.com',
        defaultStyle: { color: '#000', fontSize: '14px', iconSize: '20px', marginTop: '0px', marginRight: '0px', marginBottom: '0px', marginLeft: '0px' },
        link: ''
    },
    {
        type: ELEMENT_TYPES.DIVIDER,
        label: 'Séparateur',
        icon: '➖',
        defaultStyle: { color: '#e0e0e0', height: '1px', marginTop: '0px', marginRight: '0px', marginBottom: '0px', marginLeft: '0px' }
    },
    {
        type: ELEMENT_TYPES.SPACER,
        label: 'Espace',
        icon: '⬜',
        defaultStyle: { height: '20px', marginTop: '0px', marginRight: '0px', marginBottom: '0px', marginLeft: '0px' }
    },
    {
        type: ELEMENT_TYPES.SOCIAL,
        label: 'Social',
        icon: '🔗',
        network: 'linkedin',
        link: '#',
        defaultStyle: { size: '32px', marginTop: '0px', marginRight: '0px', marginBottom: '0px', marginLeft: '0px' }
    },
    {
        type: ELEMENT_TYPES.SOCIALGROUP,
        label: 'Groupe Social',
        icon: '🌐',
        networks: [],
        links: {},
        defaultStyle: { size: '32px', spacing: '8px', align: 'flex-start', iconStyle: 'flat', marginTop: '0px', marginRight: '0px', marginBottom: '0px', marginLeft: '0px' }
    },
    {
        type: ELEMENT_TYPES.QRCODE,
        label: 'QR Code',
        icon: '📲',
        defaultValue: 'https://example.com',
        qrData: 'https://example.com',
        defaultStyle: { size: '128', fgColor: '#000000', bgColor: '#ffffff', margin: '0', align: 'center', marginTop: '0px', marginRight: '0px', marginBottom: '0px', marginLeft: '0px' }
    }
];

// Structures de lignes
export const ROW_STRUCTURES = [
    { columns: 1, label: '1 colonne' },
    { columns: 2, label: '2 colonnes' },
    { columns: 3, label: '3 colonnes' },
    { columns: 4, label: '4 colonnes' }
];
